module.exports = __webpack_public_path__ + "static/media/product-group-default.79876599.svg";